import React, { useState, useEffect } from 'react';
import Api from '../config/Api';
import { useHistory, Link } from 'react-router-dom';

import { getUser, removeUserSession, getPermissions, checkMenu, getStyles } from '../Utils/Common';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';

import { FaCriticalRole, FaUsers, FaUserShield, FaUserNurse, FaBookMedical } from 'react-icons/fa';
import { GrUserAdmin } from "react-icons/gr";
import { AiFillDashboard, AiFillDatabase, AiOutlineQrcode, AiOutlineLeft } from "react-icons/ai";
import { BsSignpost2Fill, BsFillFileEarmarkPdfFill, BsCardChecklist, BsCardList } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdOutlineEditNote, MdOutlinePassword, MdOutlineAddAlert } from "react-icons/md";
import { RiAdminFill, RiPagesLine, RiNurseLine} from "react-icons/ri";
import { HiOutlineUsers } from "react-icons/hi";
import { GiDoctorFace, GiArtificialIntelligence, GiArchiveRegister } from "react-icons/gi";
import { confirm } from "react-confirm-box";

function SideBar() {
    const history = useHistory();
    const user = getUser();
    const { collapseSidebar } = useProSidebar();

    useEffect(() => {
    }, []);

    const handleLogout = async () => {
        const confirm_action = await confirm("Anda yakin ingin keluar dari Aplikasi ini?");
        if (confirm_action) {
            removeUserSession();
            history.push('/login');
        }
    }
    const handleMenuIcon = (e) => {
        collapseSidebar();
    }
    return (
        <Sidebar className="main-sidebar sidebar-dark-primary" defaultCollapsed={false}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="user-panel mt-3 d-flex">
                    <div className="image logo">
                        <img src="assets/img/logo_small.png" className="brand-image" />
                    </div>
                </div>
                <div className="user-panel mt-2 d-flex user-info">
                    <div className="image">
                        <img src={ user.avatar ? user.avatar : 'assets/img/user2-160x160.jpg' } className="img-circle elevation-2" alt="User Image" />
                    </div>
                    <div className="info">
                        <Link className="d-block" to="/profile">
                            {user.firstName} {user.middleName} {user.lastName}
                        </Link>
                        <span className="badge-outline">{user.roleId.name}</span>
                    </div>
                </div>

                <Menu>
                    <MenuItem className="nav-item" routerLink={<Link to="" />} icon={<AiFillDashboard />}>Dashboard</MenuItem>
                    { checkMenu('projects') && 
                        <MenuItem routerLink={<Link to="/projects" />} icon={<GiArchiveRegister />}>Projects</MenuItem>
                    }
                    { checkMenu('banners') && 
                        <MenuItem routerLink={<Link to="/banners" />} icon={<GiArchiveRegister />}>Banners</MenuItem>
                    }
                    { checkMenu('news') && 
                        <MenuItem routerLink={<Link to="/news" />} icon={<GiArchiveRegister />}>News</MenuItem>
                    }
                    { checkMenu('contents') && 
                        <MenuItem routerLink={<Link to="/contents" />} icon={<GiArchiveRegister />}>Contents</MenuItem>
                    }
                    { checkMenu('modules') || checkMenu('users') || checkMenu('roles') || checkMenu('permissions') ?
                        <SubMenu label="Admin" icon={<RiAdminFill />}>
                            { checkMenu('modules') && 
                                <MenuItem routerLink={<Link to="/modules" />} icon={<RiPagesLine />}>Modules</MenuItem>
                            }
                            { checkMenu('roles') && 
                                <MenuItem className="nav-item" routerLink={<Link to="/roles" />} icon={<FaCriticalRole />}>Roles</MenuItem>
                            }
                            { checkMenu('users') && 
                                <MenuItem className="nav-item" routerLink={<Link to="/users" />} icon={<FaUsers />}>Users</MenuItem>
                            }
                            { checkMenu('permissions') && 
                                <MenuItem className="nav-item" routerLink={<Link to="/permissions" />} icon={<FaUserShield />}>Permissions</MenuItem>
                            }
                            { checkMenu('logs') && 
                                <MenuItem className="nav-item" routerLink={<Link to="/logs" />} icon={<FaUserShield />}>Logs</MenuItem>
                            }
                        </SubMenu>
                    : ''}


                    { checkMenu('zipcodes') && 
                        <MenuItem className="nav-item" routerLink={<Link to="/zipcodes" />} icon={<BsSignpost2Fill />}>Zip Code</MenuItem>
                    }
                    { checkMenu('services') && 
                        <MenuItem className="nav-item" routerLink={<Link to="/services" />} icon={<FaUserNurse />}>Services</MenuItem>
                    }

                    { checkMenu('filemanager') && 
                        <MenuItem className="nav-item" routerLink={<Link to="/filemanager" />} icon={<BsFillFileEarmarkPdfFill />}>File Manager</MenuItem>
                    }

                    <SubMenu label="Settings " icon={<HiOutlineUsers />}>
                        { checkMenu('general') && 
                            <MenuItem className="nav-item" routerLink={<Link to="/general" />} icon={<GiDoctorFace />}>General</MenuItem>
                        }
                        <MenuItem className="nav-item" routerLink={<Link to="/profile" />} icon={<FaUserNurse />}>Profile</MenuItem>
                        <MenuItem className="nav-item" routerLink={<Link to="/changepassword" />} icon={<MdOutlinePassword />}>Change Password</MenuItem>
                    </SubMenu>
                    <MenuItem className="nav-item" onClick={handleLogout} icon={<RiNurseLine />}>Logout</MenuItem>
                    <MenuItem className="nav-item small-box-grey" onClick={handleMenuIcon} icon={<AiOutlineLeft />}>Hide</MenuItem>
                </Menu>
            </div>
        </Sidebar>
    )
}
export default SideBar;